import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import MistGradient from './MistGradient';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-visible bg-[#0a0a0a]">
      {/* Atmospheric Fog Background */}
      <div
        className="absolute pointer-events-none"
        style={{
          top: '-115px',
          left: 0,
          right: 0,
          bottom: '-76px',
          opacity: isVisible ? 1 : 0,
          transition: 'opacity 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.2s',
          zIndex: 1,
          WebkitMaskImage: 'linear-gradient(to bottom, #000 0%, #000 85%, transparent 100%)',
          maskImage: 'linear-gradient(to bottom, #000 0%, #000 85%, transparent 100%)',
        }}
      >
        <MistGradient />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto pt-20">
        {/* Badge */}
        <div className="inline-flex items-center gap-2.5 px-5 py-2.5 rounded-full border border-white/15 bg-white/[0.03] backdrop-blur-sm mb-8">
          <div className="w-2 h-2 bg-white/70 rounded-full" />
          <span className="text-white/80 text-sm font-normal tracking-wide">Footwear. Branding. Scale.</span>
        </div>

        {/* Main headline */}
        <h1 className="text-[52px] md:text-[68px] lg:text-[82px] font-extralight text-white mb-6 tracking-[-0.02em] leading-[1.08]">
          Rethinking the<br />Footwear Industry
        </h1>

        {/* Subheadline */}
        <p className="text-[#8a8a8a] text-base md:text-[17px] max-w-[600px] mx-auto mb-10 leading-[1.7] font-normal">
          A family-built footwear group creating brand-driven product at scale.<br />
          Designed fast, produced responsibly, delivered reliably.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/brands"
            className="px-7 py-3.5 bg-white text-[#0a0a0a] rounded-full text-[15px] font-medium hover:bg-white/90 transition-all duration-300 hover:scale-[1.02] active:scale-[0.98]"
          >
            Explore Brands
          </Link>
          <Link
            to="/contact"
            className="px-7 py-3.5 border border-white/20 text-white rounded-full text-[15px] font-medium hover:bg-white/5 hover:border-white/30 transition-all duration-300"
          >
            Get in Touch
          </Link>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-0 right-0 flex items-center justify-center gap-6 z-10">
        <span className="text-[#5a5a5a] text-[13px]">Scroll down</span>
        <div className="flex items-center justify-center">
          <div className="w-[22px] h-[36px] border border-white/25 rounded-full flex items-start justify-center p-[6px]">
            <div className="w-[3px] h-[6px] bg-white/60 rounded-full animate-scroll-indicator" />
          </div>
        </div>
        <span className="text-[#5a5a5a] text-[13px]">to explore</span>
      </div>
    </section>
  );
};

export default Hero;
